import React from "react";
import ProductCard from "./ProductCard";

const ProductGrid = ({ products, loading }) => {
  if (loading) {
    return (
      <div className="grid auto-rows-fr grid-cols-2 gap-2 min-[390px]:gap-2 md:grid-cols-3 md:gap-2.5 lg:grid-cols-4 lg:gap-2.5 min-[1440px]:grid-cols-5 min-[1440px]:gap-2.5">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="overflow-hidden rounded-[8px] border border-white/10 bg-cynos-card">
            <div className="aspect-[4/4.2] animate-pulse bg-cynos-surface md:aspect-[4/5]" />
            <div className="space-y-1.5 p-2">
              <div className="h-3 w-5/6 animate-pulse rounded bg-white/10" />
              <div className="h-3.5 w-1/3 animate-pulse rounded bg-white/10" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!products.length) {
    return <div className="text-center py-20 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">No products found.</div>;
  }

  return (
    <div className="grid auto-rows-fr grid-cols-2 gap-2 min-[390px]:gap-2 md:grid-cols-3 md:gap-2.5 lg:grid-cols-4 lg:gap-2.5 min-[1440px]:grid-cols-5 min-[1440px]:gap-2.5">
      {products.map((product) => (
        <ProductCard key={product._id || product.slug} product={product} />
      ))}
    </div>
  );
};

export default ProductGrid;